import clsx from "clsx";
import { type JSX, useState } from "react";

import PoweredByStripe from "common/components/PoweredByStripe";
import { Button } from "common/components/ui/Button";
import {
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
} from "common/components/ui/Drawer";
import type { SubscriptionType } from "common/types";

export default function MobileLayout({
  subscriptionType,
  subscriptionPlanComponent,
  pricingPeriodSelectionComponent,
  currentEstimateComponent,
  quantitySelectionComponent,
  pricingComponent,
  paymentSourceComponent,
  creditsComponent,
  subscriptionActionButton,
  estimateComponents,
  errorMessageComponent,
  isPaymentPreviousStep,
}: {
  subscriptionType: SubscriptionType;
  subscriptionPlanComponent: JSX.Element;
  pricingPeriodSelectionComponent: JSX.Element;
  currentEstimateComponent: JSX.Element | undefined;
  quantitySelectionComponent: JSX.Element;
  pricingComponent: JSX.Element;
  paymentSourceComponent: JSX.Element;
  creditsComponent: JSX.Element;
  subscriptionActionButton: JSX.Element;
  estimateComponents: JSX.Element;
  errorMessageComponent: JSX.Element;
  isPaymentPreviousStep: boolean;
}) {
  const [currentStep, setCurrentStep] = useState<"summary" | "manage">(
    isPaymentPreviousStep ? "summary" : "manage",
  );

  return (
    <>
      <DrawerHeader title={currentStep} />
      {currentStep === "manage" ? (
        <>
          <DrawerBody>
            <div
              className={clsx(
                "flex flex-col rounded-5xl mb-6",
                subscriptionType === "user"
                  ? "bg-[linear-gradient(332deg,_rgba(255,229,204,0.50)_2.81%,_rgba(249,250,251,0.50)_98.16%)]"
                  : "bg-[linear-gradient(332deg,_rgba(219,220,255,0.50)_2.81%,_rgba(249,250,251,0.50)_98.16%)]",
              )}
            >
              <div className="p-6">{subscriptionPlanComponent}</div>
              {currentEstimateComponent && (
                <div className="px-4 pb-4">{currentEstimateComponent}</div>
              )}
            </div>
            {pricingPeriodSelectionComponent}
            <div className="rounded-5xl flex flex-col bg-black-50 pb-1.5 gap-y-2.5">
              {quantitySelectionComponent}
              {pricingComponent}
            </div>
            {creditsComponent}
          </DrawerBody>
          <DrawerFooter className="justify-end">
            <Button onClick={() => setCurrentStep("summary")}>Next</Button>
          </DrawerFooter>
        </>
      ) : (
        <>
          <DrawerBody>
            {paymentSourceComponent}
            <div className="flex flex-col gap-y-3 mb-4 mt-6">
              <div className="bg-whiteGray flex flex-col gap-y-2.5 pb-2.5 rounded-4xl p-2">
                {currentEstimateComponent}
                {estimateComponents}
              </div>
              {errorMessageComponent}
            </div>
            <PoweredByStripe />
          </DrawerBody>
          <DrawerFooter className="justify-end">
            <Button
              variant="secondary-black"
              onClick={() => setCurrentStep("manage")}
            >
              Back
            </Button>
            {subscriptionActionButton}
          </DrawerFooter>
        </>
      )}
    </>
  );
}
